import React from 'react';
import { Button } from '../../ui/button';
import { Label } from '../../ui/label';
import { Badge } from '../../ui/badge';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';
import { HsmTemplate } from '../../../types';
import { getTemplateStatusBadge, getTemplateParameters } from '../templateHelpers';

export interface TemplatePreviewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  template: HsmTemplate | null;
}

export function TemplatePreviewDialog({
  open,
  onOpenChange,
  template,
}: TemplatePreviewDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Preview do Template</DialogTitle>
          <DialogDescription>
            {template?.name} - {template?.language}
          </DialogDescription>
        </DialogHeader>
        {template && (
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              {getTemplateStatusBadge(template.status)}
              <Badge variant="secondary">{template.category}</Badge>
            </div>
            <div className="space-y-2">
              <Label>ID do Template</Label>
              <code className="block text-xs bg-muted p-2 rounded break-all">
                {template.id}
              </code>
            </div>
            {template.components?.map((component, index) => (
              <div key={index} className="space-y-1">
                <Label className="text-xs text-muted-foreground">{component.type}</Label>
                {component.text && (
                  <div className="p-3 rounded-lg bg-green-100 dark:bg-green-900/30 text-sm whitespace-pre-wrap">
                    {component.text}
                  </div>
                )}
                {component.buttons && component.buttons.length > 0 && (
                  <div className="flex flex-wrap gap-2 mt-2">
                    {component.buttons.map((btn, btnIndex) => (
                      <Badge key={btnIndex} variant="outline">
                        {btn.text || btn.type}
                      </Badge>
                    ))}
                  </div>
                )}
              </div>
            ))}
            {getTemplateParameters(template).length > 0 && (
              <div className="p-3 rounded border bg-muted/50">
                <Label className="text-xs text-muted-foreground">Parametros necessarios</Label>
                <div className="flex flex-wrap gap-1 mt-1">
                  {getTemplateParameters(template).map((param, index) => (
                    <Badge key={index} variant="secondary">
                      {`{{${param}}}`}
                    </Badge>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
